module.exports = __webpack_public_path__ + "static/media/split.0d91e54c.png";